import React, { useState } from "react";
import {
    Box,
    Button,
    Typography,
    TextField,
    Grid2,
    MenuItem,
    FormControl,
    Select,
    InputLabel,
    InputAdornment,
    useMediaQuery,
    IconButton
} from "@mui/material";

import { useNavigate, useLocation } from "react-router-dom";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import StepperCard from "../../Signup/StepperCard";
import { CustomStepConnector, StepIcon, useSteps  } from "../../Signup/StepperComponents"; // Import steps
import { useSelector, useDispatch } from 'react-redux';
import { checkAndNavigate, checkPinCode, setActiveStep, setNominee, setNomineeStatus, submitNomineeDetails } from "../../../Redux/usersSlice";
import icon from "../../../Assets/Images/icon.svg"
import calenderIcon from "../../../Assets/Images/calenderIcon.svg"
import NomineeStyles from "./Nominee.module.css"
import navLogo from "../../../Assets/Images/logo.svg"
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; // Or use AdapterDateFns
import dayjs from 'dayjs'; // For date formatting
import { ArrowBack } from "@mui/icons-material";
import collab from '../../../Assets/Images/collab1.svg';

export default function AddNominee() {
      const steps = useSteps();
    const navigate = useNavigate();
    const location = useLocation();

    const dispatch = useDispatch();

     const {activeStep,userData,nominee,nomineeData,source} = useSelector( state => state.user);
   
     const backendResponse=userData.steps

     const isMobile = useMediaQuery('(max-width:1000px)');
    const isSmallScreen = useMediaQuery('(max-width:600px)')

    React.useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "nominee_page_viewed",
          page_path: window.location.pathname
        });
    }, [])

    // Sync step with URL path
    React.useEffect(() => {
        const currentStep = steps.findIndex(
            (step) => step.path === location.pathname
        );
        if (currentStep !== -1) dispatch(setActiveStep(currentStep));
    }, [location.pathname, setActiveStep]);

   
    const handleSkip = async () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "nominee_skipped",
            page_path: window.location.pathname
        });
        try {
            const response = await dispatch(submitNomineeDetails({
                email: userData.email.toLowerCase(),
                mobile: userData.mobile,
                nominee_name: "",
                nominee_relation: "",
                nominee_aadhaar: "",
                nominee_pincode: "",
                nominee_dob: "",
                nominee_skip: true
            })).unwrap();

            if (response.data.success) {
                dispatch(setNomineeStatus())

                let nextIncompleteStep = null;

                // Check forward steps
                for (let i = activeStep + 1; i < steps.length; i++) {
                    const step = steps[i];
                    const isComplete = step.substeps
                        ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                        : userData.steps[step.name]?.status;

                    if (!isComplete) {
                        nextIncompleteStep = step;
                        break;
                    }
                }

                // If no incomplete step forward, check all
                if (!nextIncompleteStep) {
                    for (let i = 0; i < steps.length; i++) {
                        const step = steps[i];
                        const isComplete = step.substeps
                            ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                            : userData.steps[step.name]?.status;

                        if (!isComplete) {
                            nextIncompleteStep = step;
                            break;
                        }
                    }
                }

                if (nextIncompleteStep) {
                    const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
                    if (stepIndex !== -1) {
                        dispatch(setActiveStep(stepIndex));
                        navigate(nextIncompleteStep.path);
                    }
                }
            }
        } catch (error) {
            console.error("Error while skipping nominee step:", error);
        }
    };

    const handleStepNavigate = (path) => {
        const stepIndex = steps.findIndex((step) => step.path === path);
        if (stepIndex !== -1) {
            dispatch(setActiveStep(stepIndex));
            navigate(path);
        }
    };

      const [formData, setFormData] = useState({
        nominee_name: nominee?.nominee_name || "",
        nominee_relation: nominee?.nominee_relation|| "",
        nominee_aadhaar:nominee?.nominee_aadhaar || "",
        nominee_pincode:nominee?.nominee_pincode || "",
        nominee_dob:nominee?.nominee_dob || "",
      });


    const [errors, setErrors] = useState({
        nominee_name: "",
        nominee_relation: "",
        nominee_pincode: "",
        nominee_aadhaar: "",
        nominee_dob: ""
    });
    const [submitAttempted, setSubmitAttempted] = useState(false);

    const [activeField, setActiveField] = useState(null); // Track the currently focused field

      
    React.useEffect(() => {
        if (nominee || nomineeData) {
            // Convert date format from DD/MM/YYYY to DD-MM-YYYY
            const convertDateFormat = (dateString) => {
                if (!dateString) return "";
                return dateString.replace(/\//g, "-"); // Replace all slashes with dashes
            };

            setFormData({
                nominee_name: nominee?.nominee_name || nomineeData.nominee_name || "",
                nominee_relation: nominee?.nominee_relation || nomineeData.nominee_relation || "",
                nominee_aadhaar: nominee?.nominee_aadhaar || nomineeData.nominee_aadhaar || "",
                nominee_pincode: nominee?.nominee_pincode || nomineeData.nominee_pincode || "",
                nominee_dob: convertDateFormat(nominee?.nominee_dob || nomineeData.nominee_dob || ""),
            });
        }
    }, [nominee, nomineeData]);

  const handleNomineNameChange = (e) => {
    setFormData(prev => ({ ...prev, nominee_name:e.target.value.trim()}));
  };

    const handleNomineeRelationChange = (e) => {
        setFormData(prev => ({ ...prev, nominee_relation:e.target.value }));
    };

    const handleNomineePinCodeChange = (e) => {
         setFormData(prev => ({ ...prev, nominee_pincode : e.target.value.trim()}));
         }

    const handleNomineeAadharChange = (e) => { 
        setFormData(prev => ({ ...prev, nominee_aadhaar : e.target.value.trim()}));
     
    }

    const handleNomineeDobChange = (e) => { 
        setFormData(prev => ({ ...prev, nominee_dob:e.target.value}));
     }

    // Validate a specific field
    const validateForm = () => {
        const newErrors = {};
        const dobRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
    
        if (!formData.nominee_name.trim()) {
            newErrors.nominee_name = "Nominee name is required";
        }
        if (!formData.nominee_relation) {
            newErrors.nominee_relation = "Nominee relation is required";
        }
        if (!formData.nominee_aadhaar.trim()) {
            newErrors.nominee_aadhaar = "Nominee Aadhaar is required";
        }
        if(!(/^\d{12}$/.test(formData.nominee_aadhaar))){
            newErrors.nominee_aadhaar = "Please enter valid Aadhaar number";
        }
        if (!formData.nominee_dob.trim()) {
            newErrors.nominee_dob = "Date of birth is required";
        } else if (!dobRegex.test(formData.nominee_dob)) {
            newErrors.nominee_dob = "Date must be in DD-MM-YYYY format";
        }
        if (!formData.nominee_pincode.trim()) {
            newErrors.nominee_pincode = "Pin is required";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validatePinCode = async() =>{
        const response=await dispatch(checkPinCode({pincode:formData.nominee_pincode }))
        console.log(response)
        console.log(response.payload.data)
        console.log(response.payload.data.success)
        if(response.payload.data.success){
            console.log(response.payload.data.city)
            return true
        }
        return false
    }

    const handleSubmitNominee = async() => {
        setSubmitAttempted(true);
        const isValid = validateForm();
        const isValidPinCode=await validatePinCode()
        const formattedDob = formData.nominee_dob.replace(/-/g, "/");
       
        console.log(isValid)
        console.log(isValidPinCode)
        if(isValid){
        if(!isValidPinCode){
            setErrors({nominee_pincode:"Plese Enter valid pin code"})
        }}
        if (isValid && isValidPinCode) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "kyc_step_viewed",
                step_name: "nominee_entered",
                page_path: window.location.pathname
            });
            // Proceed with form submission
            try {
                const response = await dispatch(submitNomineeDetails({
                    email: userData.email.toLowerCase(),
                    mobile: userData.mobile,
                    nominee_name:formData.nominee_name,
                    nominee_relation:formData.nominee_relation,
                    nominee_aadhaar:formData.nominee_aadhaar,
                    nominee_pincode:formData.nominee_pincode,
                    nominee_dob: formattedDob, // ✅ now dd/mm/yyyy,
                    nominee_skip: false
                })).unwrap();
    
                if (response.data.success) {
                    // Move to next step
                    dispatch(setNominee({
                        
                        email: userData.email.toLowerCase(),
                        mobile: userData.mobile,
                        nominee_name:formData.nominee_name,
                        nominee_relation:formData.nominee_relation,
                        nominee_aadhaar:formData.nominee_aadhaar,
                        nominee_pincode:formData.nominee_pincode,
                        nominee_dob: formattedDob, // ✅ now dd/mm/yyyy,
                        nominee_skip: false
                        
                    }))

                    dispatch(setNomineeStatus())

                    // if (activeStep < steps.length - 1) {

                    //     dispatch(setNomineeStatus())
                    //     const nextStep = activeStep + 1;
                    //     dispatch(setActiveStep(activeStep + 1));
                    //     navigate(steps[nextStep].path);
                    // }
                    const { payload } = await dispatch(checkAndNavigate());

                    console.log(payload.allComplete)

                    if (payload.allComplete) {
                        // All required steps completed - go to products
                        console.log("Navigating to dis page...")
                        navigate("/dis");
                    } else {

                        // First check if there are incomplete steps forward (normal flow)
                        let nextIncompleteStep = null;

                        // Check forward steps first
                        for (let i = activeStep + 1; i < steps.length; i++) {
                            const step = steps[i];
                            const isComplete = step.substeps
                                ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                                : userData.steps[step.name]?.status;
                            console.log("Forward steps completed --->", isComplete)

                            if (!isComplete) {
                                nextIncompleteStep = step;
                                console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
                                break;
                            }
                        }

                        // If no incomplete steps forward, check all steps
                        if (!nextIncompleteStep) {
                            console.log("No incomplete steps forward checking any in backward steps")
                            for (let i = 0; i < steps.length; i++) {
                                const step = steps[i];
                                const isComplete = step.substeps
                                    ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                                    : userData.steps[step.name]?.status;

                                if (!isComplete) {
                                    nextIncompleteStep = step;
                                    console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
                                    break;
                                }
                            }
                        }

                        const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
                        console.log("Navigating to the specific step according to the condition", stepIndex)
                        if (stepIndex !== -1) {
                            dispatch(setActiveStep(stepIndex));
                            navigate(nextIncompleteStep.path);
                        }

                    }
                }
            } catch (error) {
                console.error("Failed to submit nominee details:", error);
            }
        }
    };

    return (
        <main>
        <Box sx={{
            display: "flex",
            flexDirection:isMobile ? "column" : "row",
            justifyContent: "flex-start !important",
            minHeight: "100vh !important",
            backgroundImage: `url(${SignUpBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }}>

         <Typography
                 sx={{
                   textAlign: "center",
                   fontSize: "16px",
                   fontFamily: "Inter400",
                   display: {
                     xs: "block", // shown on small screens
                   },
                   mt: "5px",
                   "@media (min-width:1000px)": {
                     display: "none"
                   }
                 }}
               >
                 {`You are on step ${activeStep + 1} out of 8`}
               </Typography>
               
            <StepperCard
                activeStep={activeStep}
                handleStepNavigate={handleStepNavigate}
                backendResponse={backendResponse}
                CustomStepConnector={CustomStepConnector}
                StepIcon={StepIcon}
                steps={steps}
            />

  

                {/* Your content area */}
            <Box className={NomineeStyles.content_wrapper}>

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection:"column",
                    position: 'relative',
                    width: '100%',
                    marginBottom: '10px',
                    marginTop: '10px',
                }}>
                    {/* Back arrow button - only shows below 1000px */}
                    <Box sx={{
                        position: 'absolute',
                        left: 0,

                        '@media (min-width: 1000px)': {
                            display: 'none' // Explicitly hide above 1000px
                        },
                        '@media (max-width: 510px)': {
                            marginBottom: "20px"
                        }
                    }}>
                        <IconButton
                            onClick={() => navigate('/step-5')} // Or your custom back handler
                            aria-label="Go back"
                            sx={{
                                color: '#000', // Customize color
                                padding: '16px',
                                '@media (max-width: 400px)': {
                                    paddingLeft: "5px"
                                }
                            }}
                        >
                            <ArrowBack /> {/* Make sure to import from @mui/icons-material */}
                        </IconButton>
                    </Box>

                    {/* Logo - centered */}
                    <img
                        src={source == "cosmos" ? collab : navLogo}
                        alt="Logo"
                        style={{
                            // Adjust margin to account for arrow on mobile
                            marginLeft: { xs: '40px', md: 0 }
                        }}
                        className={source == "cosmos" ? NomineeStyles.twologo :
                            NomineeStyles.nav_logo}
                    />
                    {
                        source == "cosmos" &&
                        <Typography className={NomineeStyles.txt1}>
                            Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                        </Typography>
                    }
                </Box>

                <Typography className={NomineeStyles.title}>Add nominee</Typography>

                <TextField
                    variant="outlined"
                    placeholder="Enter Nominee Name"
                    value={formData.nominee_name}
                   onChange={handleNomineNameChange}
                    sx={{
                        backgroundColor: "white",
                        borderRadius: "39px",
                        marginTop: "24px",
                        "@media (max-height:735px)": {
                            marginTop: "10px !important"
                        },
                        "@media (max-width:600px)": {
                            marginTop: "10px !important"
                        },
                        
                        "& input": {
                            display: "flex",
                            alignItems: "center",
                            padding: "12px 12px",
                            textAlign: "center !important",
                            fontFamily: "Inter400 !important",
                            fontSize: "18px !important",
                            lineHeight: "21.78px !important",
                        },
                        "& input::placeholder": {
                            color: "#767676",
                            opacity: 1, // Required for Firefox
                        },
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                                borderRadius: "39px",
                                height: "46px !important",
                                width: "399px !impoertant",
                                borderColor: "#D9D9D9",
                            },
                            "&:hover fieldset": {
                                borderColor: "#D9D9D9", // Keep border color consistent on hover
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "#D9D9D9",
                                borderWidth: "1px",
                            },
                        },
                        width: "399px",
                        height: "42px !important",
                        "@media (max-width: 1000px)": {
                            width: "316px",
                            height: "45px !important",
                            "& input": {
                                fontSize: "18px !important",
                            },
                            "& .MuiOutlinedInput-root fieldset": {
                                height: "50px !important",
                                width: "299px !important",
                            },
                        },
                        "@media (max-width: 1000px)": {
                            width: "315px",
                            height: "45px !important",
                            "& input": {
                                fontSize: "18px !important",
                            },
                            "& .MuiOutlinedInput-root fieldset": {
                                height: "50px !important",
                                width: "299px !important",
                            },
                        },
                        "@media (max-width: 600px)": {
                            width: "288px",
                            height: "45px !important",
                            "& input": {
                                fontSize: "18px !important",
                            },
                            "& .MuiOutlinedInput-root fieldset": {
                                height: "50px !important",
                                width: "270px !important",
                            },
                        },
                    }}
                />

                {submitAttempted && errors.nominee_name && (
                    <p style={{ color: "red", fontSize: "12px", margin: "4px",fontFamily:"Inter400" }}>
                        {errors.nominee_name}
                    </p>
                )}


                <FormControl
                    className={`${NomineeStyles.formControl}`}

                >
                    <InputLabel
                        id="nominee-relation-label"
                        className={`${NomineeStyles.label}`}
                        shrink={false} // Prevent Material-UI's default shrink behavior
                        sx={{
                            position: "absolute",
                            top: "50%", // Center the label vertically
                            left: "16px",
                            transform: "translateY(-50%)",
                            // fontSize: "18px",
                            color: "#727070",
                            pointerEvents: "none",
                            transition: "all 0.2s ease",
                            display: formData.nominee_relation ? "none" : "block",
                            "@media (max-width: 1250px)": { left: "34px" },
                            "@media (max-width: 1150px)": { left: "15px" },
                            "@media (max-width: 1080px)": { left: "0px" },
                        }}
                    >
                        Nominee Relation
                    </InputLabel>
                    <Select
                        labelId="nominee-relation-label"
                        value={formData.nominee_relation}
                        onChange={handleNomineeRelationChange}
                        displayEmpty
                        className={`${NomineeStyles.select}`}
                        sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none", // Remove the notched outline
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                        }}
                    >
                       <MenuItem className={NomineeStyles.item} value="Father">
                                Father
                            </MenuItem>
                            <MenuItem className={NomineeStyles.item} value="Mother">
                                Mother
                            </MenuItem>
                            <MenuItem className={NomineeStyles.item} value="Sibling">
                                Sibling
                            </MenuItem>
                            <MenuItem className={NomineeStyles.item} value="Son">
                                Son
                            </MenuItem>
                            <MenuItem className={NomineeStyles.item} value="Brother">
                            Brother
                            </MenuItem>
                            <MenuItem className={NomineeStyles.item} value="Sister">
                            Sister
                            </MenuItem>
                            
                            <MenuItem className={NomineeStyles.item} value="Grand-Son">
                            Grand-Son
                            </MenuItem>
                            
                            <MenuItem className={NomineeStyles.item} value="Grand-Daughter">
                            Grand-Daughter
                            </MenuItem>

                            <MenuItem className={NomineeStyles.item} value="Daughter">
                                Daughter
                            </MenuItem>

                            <MenuItem className={NomineeStyles.item} value="Grand-Father">
                            Grand-Father
                            </MenuItem>

                            <MenuItem className={NomineeStyles.item} value="Grand-Mother">
                            Grand-Mother
                            </MenuItem>

                          <MenuItem className={NomineeStyles.item} value="Spouse">
                            Spouse
                        </MenuItem>

                        <MenuItem className={NomineeStyles.item} value="Others">
                            Others
                        </MenuItem>
                    </Select>
                </FormControl>
                {submitAttempted && errors.nominee_relation && (
                    <p style={{ color: "red", fontSize: "12px", margin: "4px",fontFamily:"Inter400" }}>
                        {errors.nominee_relation}
                    </p>
                )}

                <TextField
                    // variant="outlined"
                    placeholder="Nominee aadhaar number"
                    value={formData.nominee_aadhaar}
                    onChange={handleNomineeAadharChange}

                    sx={{
                        backgroundColor: "white",
                        borderRadius: "39px",
                        marginTop: "15px !important",
                        "& input::placeholder": {
                            color: "#767676",
                            opacity: 1, // Required for Firefox
                        },
                        "& input": {
                            display: "flex",
                            alignItems: "center",
                            padding: "11px 12px",
                            textAlign: "center !important",
                            fontFamily: "Inter400 !important",
                            fontSize: "18px !important",
                            lineHeight: "21.78px !important",


                        },
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                                padding: "0px 12px",
                                borderRadius: "39px",
                                height: "45px !important",
                                width: "399px !impoertant",
                                borderColor: "#D9D9D9",


                            },
                            "&:hover fieldset": {
                                borderColor: "#D9D9D9", // Keep border color consistent on hover
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "#D9D9D9",
                                borderWidth: "1px",
                            },
                        },
                        width: "399px",
                        height: "42px !important",
                        "@media (max-width: 1000px)": {
                            width: "325px",
                            height: "46px !important",
                            "& input": {
                                fontSize: "18px !important",
                            },
                            "& .MuiOutlinedInput-root fieldset": {
                                height: "50px !important",
                                width: "299px !important",
                            },
                        },
                        "@media (max-width: 600px)": {
                            width: "288px",
                            height: "46px !important",
                            "& input": {
                                fontSize: "18px !important",
                            },
                            "& .MuiOutlinedInput-root fieldset": {
                                height: "50px !important",
                                width: "262px !important",
                            },
                        },
                    }}
                />

                {submitAttempted && errors.nominee_aadhaar && (
                    <p style={{ color: "red", fontSize: "12px", margin: "4px" ,fontFamily:"Inter400"}}>
                        {errors.nominee_aadhaar}
                    </p>
                )}

                <Grid2 className={NomineeStyles.inner_card}>

                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            disableFuture
                            inputFormat="DD-MM-YYYY"
                              label="Date of Birth"
                            value={formData.nominee_dob ? dayjs(formData.nominee_dob, "DD-MM-YYYY") : null}
                            onChange={(date) => {
                                if (date) {
                                    const formatted = dayjs(date).format("DD-MM-YYYY");
                                    handleNomineeDobChange({ target: { value: formatted } });
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    // placeholder="Date of Birth"
                                    sx={{
                                        backgroundColor: "white",
                                        borderRadius: "39px",
                                        marginTop: "16px",
                                        width: "210px",
                                        height: "42px !important",
                                        "@media (max-width:1000px)": {
                                            width: "160px",
                                            height: "45px !important",
                                        },
                                  
                                        // ✨ Center the label
                                        "& .MuiInputLabel-root": {
                                          left: "50%",
                                          transform: "translateX(-50%)",
                                          marginTop:"10px",
                                        //   transform: "translateY(-50%)",
                                        color:"#979797",
                                          textAlign: "center",
                                          width: "100%",
                                          fontSize: "16px",
                                          fontFamily: "Inter400 !important",
                                        },
                                  
                                        // ✨ When label is focused or shrinks (on typing), keep it centered
                                        "& .MuiInputLabel-shrink": {
                                            // please give code for this
                                            left: "50% !important",
                                            transform: "translateX(-54%) translateY(-18px) scale(0.75) !important",
                                            textAlign: "center",
                                            width: "100%",
                                        },
                                  
                                        "& .MuiInputBase-input": {
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "8px 12px !important",
                                          textAlign: "center !important",
                                          fontFamily: "Inter400 !important",
                                          fontSize: "18px !important",
                                          lineHeight: "21.78px !important",
                                          "@media (max-height:1000px)": {
                                            padding: "8px 0px 15px 5px !important",
                                          },
                                          "@media (max-width: 1250px)": {
                                            "& ::placeholder": {
                                              width: "fitContent",
                                              fontSize: "17px !important",
                                            },
                                            
                                          },
                                        },
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": {
                                            padding: "0px 0px 0px 30px",
                                            borderRadius: "39px",
                                            height: "44px !important",
                                            width: "180px !important",
                                            borderColor: "#D9D9D9",
                                            "@media (max-width:1000px)": {
                                             width: "130px !important",
                                             height: "50px !important",
                                            },
                                                
                                          },
                                          "&:hover fieldset": {
                                            borderColor: "#D9D9D9",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "#D9D9D9",
                                            borderWidth: "1px",
                                          },
                                            
                                        },
                                      }}
                                />
                            )}
                        />
               </LocalizationProvider> */}




                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            disableFuture
                            inputFormat="DD-MM-YYYY"
                            label="Date of Birth"
                            value={formData.nominee_dob ? dayjs(formData.nominee_dob, "DD-MM-YYYY") : null}
                            onChange={(date) => {
                                if (date) {
                                    const formatted = dayjs(date).format("DD-MM-YYYY");
                                    handleNomineeDobChange({ target: { value: formatted } });
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    sx={{
                                        backgroundColor: "white",
                                        borderRadius: "39px",
                                        marginTop: "15px",
                                        width: "210px",
                                        height: "40px !important",
                                        "@media (max-width:1000px)": {
                                            padding: "0px !important",
                                            width: "160px",
                                            height: "45px !important",
                                        },
                                        "@media (max-width:600px)": {
                                            width: "288px !important",
                                            height: "42px !important",
                                        },
                                        "& .MuiInputLabel-root": {
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            marginTop: "10px",
                                            color: "#727070",
                                            textAlign: "center",
                                            width: "100% !important",
                                            fontSize: "16px",
                                            fontFamily: "Inter400 !important",
                                            "@media (max-width:1000px)": {
                                                marginTop: "12px",
                                                left: "45% !important",
                                            },
                                            "@media (max-width:600px)": {
                                                marginTop: "10px",
                                                left: "50% !important",
                                            },
                                        },
                                        "& .MuiInputLabel-shrink": {
                                            left: "50% !important",
                                            transform: "translateX(-54%) translateY(-18px) scale(0.75) !important",
                                            textAlign: "center",
                                            width: "100% !important ",
                                            "@media (max-width:1000px)": {
                                                left: "45% !important",
                                            },
                                            "@media (max-width:600px)": {

                                                left: "32% !important",
                                            },
                                        },
                                        "& .MuiInputBase-input": {
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "8px 12px !important",
                                            textAlign: "center !important",
                                            fontFamily: "Inter400 !important",
                                            fontSize: "18px !important",
                                            lineHeight: "21.78px !important",
                                            "@media (max-width:1000px)": {
                                                fontSize: "16px !important",
                                                padding: "16px 0px 8px 12px !important",
                                                textAlign: "start !important",
                                            },
                                            "@media (max-width:600px)": {
                                                padding: "12px 0px 8px 85px !important",
                                            },


                                        },
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                padding: "0px 0px 0px 30px",
                                                borderRadius: "39px",
                                                height: "44px !important",
                                                width: "180px !important",
                                                borderColor: "#D9D9D9",
                                                "@media (max-width:1000px)": {
                                                    padding: "0px !important",
                                                    width: "160px !important",
                                                    height: "48px !important",
                                                },
                                                "@media (max-width:600px)": {
                                                    padding: "0px !important",
                                                    width: "288px !important",
                                                    height: "45px !important",
                                                },
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#D9D9D9",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#D9D9D9",
                                                borderWidth: "1px",
                                            },
                                        },
                                    }}
                                />
                            )}
                        />
                    </LocalizationProvider>






                    <TextField
                        // variant="outlined"
                        placeholder="Pin Code"
                        value={formData.nominee_pincode}
                        onChange={ handleNomineePinCodeChange}
                        sx={{
                            backgroundColor: "white",
                            borderRadius: "39px",
                            marginTop: "15px",
                            "& input": {
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                textAlign: "center !important",
                                fontFamily: "Inter400 !important",
                                fontSize: "18px !important",
                                lineHeight: "21.78px !important",
                            },
                            "& input::placeholder": {
                                color: "#767676",
                                opacity: 1, // Required for Firefox
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    padding: "11px 12px",
                                    borderRadius: "39px",
                                    height: "22px !important",
                                    width: "145px !important",
                                    borderColor: "#D9D9D9",


                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#D9D9D9",
                                    borderWidth: "1px",
                                },
                            },
                            width: "170px",
                            height: "40px !important",
                            "@media (max-width: 1000px)": {
                                width: "150px",
                                height: "42px !important",
                                "& input": {
                                    fontSize: "18px !important",
                                },
                                "& .MuiOutlinedInput-root fieldset": {
                                    height: "25px !important",
                                    width: "125px !important",
                                   
                                },
                            },
                            "@media (max-width: 600px)": {
                                width: "288px",
                                height: "42px !important",
                                "& input": {
                                    fontSize: "18px !important",
                                },
                                "& .MuiOutlinedInput-root fieldset": {
                                    height: "30px !important",
                                    width: "135px !important",
                                    "@media (max-height:1000px)": {
                                        width: "263px !important",
                                        height: "25px !important",
                                    },
                                },
                            },
                        }}
                    />
                </Grid2>

                {submitAttempted && errors.nominee_dob && (
                    <p style={{ color: "red", fontSize: "12px", margin: "4px" ,fontFamily:"Inter400"}}>
                        {errors.nominee_dob}
                    </p>
                )}

                {submitAttempted && errors.nominee_pincode && (
                    <p style={{ color: "red", fontSize: "12px", margin: "4px" ,fontFamily:"Inter400"}}>
                        {errors.nominee_pincode}
                    </p>
                )}

                <Grid2 className={NomineeStyles.but_card}>
                    <Grid2>
                    {!(nominee || nomineeData) && <Button className={NomineeStyles.skip_button} variant="outlined" onClick={handleSkip}>
                            Do It Later
                        </Button>}
                    </Grid2>
                    <Grid2>
                        <Button
                            className={NomineeStyles.con_button}
                            onClick={handleSubmitNominee}
                        >
                            Continue
                        </Button>
                    </Grid2>
                </Grid2>

                {
                    isSmallScreen ?
                        <>
                            <Typography className={NomineeStyles.footerText}>
                                This helps to avoid any delay in the transfer of securities, which could cause financial hardship for the family. Additionally, appointing a nominee for a Demat account is essential to estate planning, which can help secure the family's future.
                            </Typography></> :
                        <>
                            <Typography className={NomineeStyles.footerText}>
                                This helps to avoid any delay in the transfer of securities, which
                                could cause financial hardship for the family.
                            </Typography>
                            <Typography className={NomineeStyles.footerText1} sx={{

                            }}>
                                Additionally, appointing a nominee for a Demat account is essential
                                to estate planning, which can help secure the family's future.
                            </Typography>
                        </>
                }

                <Box className={NomineeStyles.txt_card}>
                    <img
                        src={icon} // Replace with your image URL
                        alt="Checkmark"
                        className={NomineeStyles.icon}
                    />
                    <Typography className={NomineeStyles.txt}>
                        Your account details are safe & secure with us.
                    </Typography>
                </Box>
            </Box>
          
        </Box>
        </main>
    );
}